"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utils_1 = require("./Utils");
/**
 * Component for handling default/native scrolling for the DataGrid.
 */
var DefaultScrollComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultScrollComponent, _super);
    function DefaultScrollComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measuredScrollbarWidth = 17; // 17 is the default on basically all platforms
        _this.element = null;
        _this.onScroll = function (e) {
            _this.props.onScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop);
        };
        _this.handleRef = function (element) {
            _this.element = element;
            _this.props.onRefUpdated(element ? _this : null);
            if (element) {
                _this.measuredScrollbarWidth = Utils_1.measureScrollbarWidth(element);
            }
        };
        return _this;
    }
    DefaultScrollComponent.prototype.render = function () {
        return (React.createElement("div", { className: this.props.rootCssClass, 
            // tslint:disable-next-line:deprecation
            id: this.props.scrollingRootId, onScroll: this.onScroll, ref: this.handleRef, style: {
                top: this.props.marginTop,
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                position: 'absolute',
                right: 0,
                bottom: 0,
                left: 0,
            } }, this.props.children));
    };
    DefaultScrollComponent.prototype.getScrollbarWidth = function () {
        return this.measuredScrollbarWidth;
    };
    DefaultScrollComponent.prototype.getScrollPosition = function () {
        if (!this.element) {
            return { scrollLeft: 0, scrollTop: 0 };
        }
        return { scrollLeft: this.element.scrollLeft, scrollTop: this.element.scrollTop };
    };
    DefaultScrollComponent.prototype.setScrollPosition = function (scrollLeft, scrollTop) {
        if (!this.element) {
            return;
        }
        if (!!scrollLeft || scrollLeft === 0) {
            this.element.scrollLeft = scrollLeft;
        }
        if (!!scrollTop || scrollTop === 0) {
            this.element.scrollTop = scrollTop;
        }
    };
    DefaultScrollComponent.prototype.scrollBy = function (x, y) {
        if (!this.element) {
            return;
        }
        var dom = this.element;
        var newLeft = Math.min(Math.max(dom.scrollLeft + x, 0), dom.scrollWidth);
        var newTop = Math.min(Math.max(dom.scrollTop + y, 0), dom.scrollHeight);
        this.setScrollPosition(newLeft, newTop);
    };
    /**
     * Native scroll doesn't need to clean up anything special
     */
    // tslint:disable-next-line:no-empty
    DefaultScrollComponent.prototype.dispose = function () { };
    DefaultScrollComponent.prototype.resetPosition = function () {
        this.setScrollPosition(0, 0);
    };
    /**
     * Native scroll doesn't need to do any special refreshing.
     */
    // tslint:disable-next-line:no-empty
    DefaultScrollComponent.prototype.refresh = function () { };
    /**
     * All events are handled natively, so nothing special to do here.
     * This also means however, that any interception of events might break scrolling.
     */
    // tslint:disable-next-line:no-empty
    DefaultScrollComponent.prototype.handleEvent = function (e) { };
    DefaultScrollComponent.prototype.canScroll = function () {
        if (!this.element) {
            return false;
        }
        var dom = this.element;
        var hasHorizontalScrollbar = dom.scrollWidth > dom.clientWidth;
        var hasVerticalScrollbar = dom.scrollHeight > dom.clientHeight;
        return hasHorizontalScrollbar || hasVerticalScrollbar;
    };
    DefaultScrollComponent.prototype.getScrollContainer = function () {
        return this.element;
    };
    return DefaultScrollComponent;
}(React.PureComponent));
exports.DefaultScrollComponent = DefaultScrollComponent;
//# sourceMappingURL=DefaultScrollComponent.js.map